<template>
  <a-layout id="layout">
    <a-layout-sider v-model="collapsed" collapsedWidth="0" :trigger="null" collapsible style="overflow-y: scroll;">
      <div class="logo">易成数学</div>
      <or-aside :menu-list="menuList" />
      <!-- <a-affix :offsetTop="0">
                <div>
                    <div class="logo">易成数学</div>
                    <or-aside :menu-list="menuList"/>
                </div>
            </a-affix> -->
    </a-layout-sider>
    <a-layout>
      <a-affix :offsetTop="0">
        <a-layout-header style="background: #fff; padding: 0">
          <div class="header">
            <div>
              <a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="() => (collapsed = !collapsed)" />
            </div>
            <div>
              <span style="padding-right: 1rem;">
                机构：{{ orgroleinfo.org.name }}
              </span>
              <span style="padding-right: 1rem;">
                校区：{{ orgroleinfo.campus.name }}
              </span>
              <span style="padding-right: 1rem;">
                角色：{{ orgroleinfo.role.name }}
              </span>

              <a-dropdown :trigger="['click']" style="margin-right: 1.5rem;">
                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                  <a-avatar icon="user" />
                </a>
                <a-menu class="user-menu" slot="overlay">
                  <a-menu-item>
                    <router-link to="/my">个人信息</router-link>
                  </a-menu-item>
                  <a-menu-item>
                    <a href="javascript:;">修改密码</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="showchangeOrgModal" href="javascript:;">切换角色</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="logout" href="javascript:;">退出登录</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </div>
        </a-layout-header>
      </a-affix>
      <a-layout-content
        :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px', overflowY: 'scroll' }">
        <slot></slot>
      </a-layout-content>
    </a-layout>
    <a-modal loading="loading" :destroyOnClose="true" :visible="change_org_visible" @ok="changeOrg"
      @cancel="change_org_visible = false" title="切换机构角色">
      <a-form>
        <a-form-item>
          <a-select placeholder="选择机构" v-model="edit_form.org_id" @change="getrolebyorg">
            <a-select-option key="select_org" :value="undefined">全部</a-select-option>
            <a-select-option v-for="(item) in changeOrgList" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select placeholder="选择校区" allow-clear v-model="edit_form.campus_id">
            <a-select-option v-for="(item) in org_campus_list" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select placeholder="选择角色" v-model="edit_form.role_id">
            <a-select-option v-for="(item) in org_role_list" :key="item.id" :value="item.id">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-layout>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import OrAside from "@/components/aside";

export default {
  name: "layout",
  data() {
    return {
      collapsed: false,
      menuList: [],
      orgList: [],
      loading: false,
      change_org_visible: false,
      changeOrgList: [],
      org_role_list: [],
      org_campus_list: [],
      orgroleinfo: {
        org: {
          name: '全部',
        },
        campus: {
          name: '全部',
        },
        role: {
          name: '全部',
        },

      },
      edit_form: {
        org_id: undefined,
        campus_id: undefined,
        role_id: undefined
      }
    };
  },
  mounted() {
    this.getorgroleinfo();
    this.loading = true;
    if (this.aside.menuData.length === 0) {
      this.getMenuList();
    }

    if (this.organizationData.length === 0) {
      this.getOrgCampus();
    }
    else {
      this.orgList = this.organizationData;
    }
    this.check_user_default();
  },
  methods: {
    /**
     * 检查老师是否设置了默认校区角色
     */
    check_user_default() {
      if (localStorage.getItem("isset_default_org") != 'isset') {
        this.$axios
          .post("/api/Admin/checkdefautorgorrole", {
            data: this.edit_form
          })
          .then(res => {
            if (res.code == 400) {
              localStorage.setItem("isset_default_org", 'noset');
              this.showchangeOrgModal();
            } else {
              localStorage.setItem('isset_default_org', 'isset');
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    // 获取默认机构与校区角色的名字
    getorgroleinfo() {
      this.$axios
        .post("/api/Admin/getmorenorg")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.orgroleinfo = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    changeOrg() {
      if (!this.edit_form.role_id) {
        this.$error({
          title: "错误",
          content: " 角色是必选项",
          okText: "确定"
        });
      }
      // if (!this.edit_form.org_id || !this.edit_form.role_id) {
      //   this.$error({
      //     title: "错误",
      //     content: "机构和角色是必须项",
      //     okText: "确定"
      //   });
      // }
      this.$axios
        .post("/api/Admin/setdefaultorgrole", {
          data: this.edit_form
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.$router.push("/");
            window.location.reload();
          }
        })
        .catch(err => {
          console.error(err);
        });

    },
    showchangeOrgModal() {
      this.$axios
        .post("/api/Admin/getorglist")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.changeOrgList = res.data;
            // this.edit_form.org_id = this.changeOrgList[0]['id'];
            this.getrolebyorg();
            this.change_org_visible = true;
            // this.change_org_visible = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },


    getrolebyorg() {
      // if (!this.edit_form.org_id) {
      //   this.$error({
      //     title: "错误",
      //     content: "请选择机构",
      //     okText: "确定"
      //   });
      // }
      this.edit_form.role_id = undefined;
      this.edit_form.campus_id = undefined;
      this.$axios
        .post("/api/AuthRole/getrolebyorg", {
          data: {
            org_id: this.edit_form.org_id
          }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.org_role_list = res.data;
            if (this.org_role_list.length > 0) {
              this.edit_form.role_id = this.org_role_list[0]['id'];
            }
            this.getmyorgcampuslist();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    getmyorgcampuslist() {
      if (!this.edit_form.org_id) {
        return false;
        // this.$error({
        //   title: "错误",
        //   content: "请选择机构",
        //   okText: "确定"
        // });
      }
      this.$axios
        .post("/api/OrgCampus/getmyorgcampuslist", {
          data: {
            org_id: this.edit_form.org_id
          }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.org_campus_list = res.data;
            if (this.org_campus_list.length > 0) {
              this.edit_form.campus_id = this.org_campus_list[0]['id'];
            }
            this.loading = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },

    changeCampus(campusId) {
      console.info(campusId);
    },
    logout() {
      this.changeState({ name: "userinfo", value: null });
      this.changeState({
        name: "aside", value: {
          openKeys: [],
          selectedKeys: [],
          menuData: []
        }
      });
      localStorage.clear();
      this.$router.push("/login");
    },
    getMenuList() {
      this.$axios
        .post("/api/Admin/getmyrule")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {

            const aside = { ...this.aside };
            aside.menuData = res.data;
            this.changeState({ name: "aside", value: aside });
            this.menuList = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getOrgCampus() {
      this.$axios
        .post("/api/Admin/getorgcampus")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.orgList = res.data;
            this.changeState({
              name: "organizationData",
              value: res.data
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    ...mapMutations(["changeState"])
  },
  components: { OrAside },
  computed: { ...mapState(["aside", "organizationData", 'campusInfo', 'userinfo']) }
};
</script>
<style lang="less" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  /deep/ .ant-dropdown-menu-submenu-arrow {
    margin-left: 10px;
  }
}

.user-menu {
  /deep/ .ant-dropdown-menu-submenu-arrow {
    color: #ff0000;
    right: 4px;
  }
}

#layout {
  height: 100vh;
}

#layout .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#layout .trigger:hover {
  color: #1890ff;
}

#layout .logo {
  font-size: 1rem;
  letter-spacing: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
  line-height: 2rem;
  text-align: center;
  background: rgba(255, 255, 255, 0.2);
  margin: 1rem;
  white-space: nowrap;
}
</style>
